import Form from "react-bootstrap/Form";

const buildTimeQuestion = (question) => {
  return (
    <Form.Control
      name={question.Name}
      type="time"
      required={question.IsMandatory}
    ></Form.Control>
  );
};

export default buildTimeQuestion;
